<template>
  <div v-if="mainData" class="X">
    <div class="row mb-3">
      <!-- ========================= -->
      <div v-for="(x, i) in 4" :key="i + '--a'" class="col" :class="{ 'pl-0': i }">
        <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'wg-alert' : 'bg-white'" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + x].description">
          <span class="symbol symbol-circle symbol-40 mr-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'symbol-danger' : 'symbol-light-primary'">
            <span class="symbol-label">
              <i v-if="i === 0" class="ri-calendar-line" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-dark'"></i>
              <i v-else-if="i === 1" class="ri-calendar-check-line" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-dark'"></i>
              <i v-else-if="i === 2" class="ri-file-edit-line" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-dark'"></i>
              <i v-else-if="i === 3" class="ri-map-pin-time-line" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-dark'"></i>
              <i v-else class="ri-timer-line" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-dark'"></i>
            </span>
          </span>
          <div class="flex-fill ml-2">
            <div class="d-flex align-items-center justify-content-between">
              <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
              <i style="line-height: 1;" class="ri-information-line pl-2" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-mute'"></i>
            </div>
            <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-' + x].data || '-' | parse('longDate') }}</span>
          </div>
        </div>
      </div>
      <!-- ========================= -->
      <div v-for="(x, i) in [20, 21, 22]" :key="i + '--b'" class="col-auto pl-0">
        <div class="d-flex min-w-150px align-items-center border border-muted rounded px-4 py-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'wg-alert' : 'bg-white'" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + x].description">
          <span class="symbol symbol-circle symbol-40 mr-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'symbol-danger' : 'symbol-light-primary'">
            <span class="symbol-label">
              <i class="ri-timer-line" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-dark'"></i>
            </span>
          </span>
          <div class="flex-fill ml-2">
            <div class="d-flex align-items-center">
              <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
              <i style="line-height: 1;" class="ri-information-line pl-2" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-mute'"></i>
            </div>
            <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-' + x].data || '-' | parse('longDate') }}</span>
          </div>
        </div>
      </div>
      <!-- ========================= -->
      <div class="col d-flex pl-0">
        <div v-if="countDown" class="min-w-150px flex-fill align-items-center border border-muted rounded px-4 py-1" :class="countDown[1] ? 'wg-alert' : 'bg-white'">
          <span class="d-block text-center font-weight-bold flex-fill text-value">Remaining Days</span>
          <div class="d-flex align-items-center justify-content-between px-5">
            <div class="font-size-h2 font-weight-boldest text-value text-center">{{ ('00' + countDown[0].days.res).slice(-2) }}</div>
            <div class="font-size-h2 font-weight-boldest text-value text-center">:</div>
            <div class="font-size-h2 font-weight-boldest text-value text-center">{{ ('00' + countDown[0].hours.res).slice(-2) }}</div>
            <div class="font-size-h2 font-weight-boldest text-value text-center">:</div>
            <div class="font-size-h2 font-weight-boldest text-value text-center">{{ ('00' + countDown[0].min.res).slice(-2) }}</div>
            <div class="font-size-h2 font-weight-boldest text-value text-center">:</div>
            <div class="font-size-h2 font-weight-boldest text-value text-center">{{ ('00' + countDown[0].sec.res).slice(-2) }}</div>
          </div>
        </div>
        <!-- <div class="pointer min-w-150px align-items-center border border-muted bg-light-primary rounded px-4 py-3 ml-4 flex-fill">
                  <span class="d-block text-center text-uppercase font-weight-bolder flex-fill text-primary">Start</span>
                  <span class="d-block text-center text-uppercase font-weight-bolder flex-fill text-primary">Presentation Page</span>
                </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-4 pr-0">
        <div class="card card-custom mb-3">
          <div class="card-body py-4 pr-3 pl-4">
            <table class="table mb-0">
              <tr v-for="(x, i) in [5, 6, 7]" :key="i + '--t'">
                <td class="pb-0 nowrap-table border-0">
                  <div class="d-flex align-items-center justify-content-between pt-1">
                    <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
                    <i style="line-height: 1;" class="ri-information-line pl-2"></i>
                  </div>
                </td>
                <td class="pb-0 border-0">
                  <b-progress :max="100" height="2rem" :variant="['info', 'success', 'warning'][i]">
                    <b-progress-bar :value="mainData['pc-component-' + x].data.prosentase_value">
                      <span>
                        <strong>{{ mainData['pc-component-' + x].data.prosentase_value }}%</strong>
                      </span>
                    </b-progress-bar>
                  </b-progress>
                  <span class="d-block font-weight-bolder font-size-sm flex-fill text-value">{{ mainData['pc-component-' + x].data.cost_value_value | parse('money') }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="card card-custom mb-3">
          <div class="card-body pt-4 pb-0 pr-3 pl-4">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-25'].description">
                <span class="font-weight-bolder">{{ mainData['pc-component-25'].name }}</span>
                <i class="ri-information-line text-muted font-weight-bold pl-5"></i>
              </div>
              <!-- <a @click="redirect('project-performance-index')" class="d-flex align-items-center pointer text-dark font-size-sm font-weight-bolder">
                        <span class="pr-2">Detail</span>
                        <i class="ri-arrow-right-line text-dark font-size-sm font-weight-bold"></i>
                      </a> -->
            </div>
            <apexchart v-if="chartSeries['pc-component-25']" :type="'line'" :height="275" :options="performanceChartOption" :series="chartSeries['pc-component-25']"></apexchart>
          </div>
        </div>
        <div class="card card-custom">
          <div class="card-body pt-4 pb-0 pr-3 pl-4">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-24'].description">
                <span class="font-weight-bolder">{{ mainData['pc-component-24'].name }}</span>
                <i class="ri-information-line text-muted font-weight-bold pl-5"></i>
              </div>
              <!-- <a @click="redirect('project-performance-index')" class="d-flex align-items-center pointer text-dark font-size-sm font-weight-bolder">
                        <span class="pr-2">Detail</span>
                        <i class="ri-arrow-right-line text-dark font-size-sm font-weight-bold"></i>
                      </a> -->
            </div>
            <apexchart v-if="chartSeries['pc-component-24']" :type="'line'" :height="275" :options="evmChartOption" :series="chartSeries['pc-component-24']"></apexchart>
          </div>
        </div>
      </div>
      <div class="col-4 pr-0">
        <div class="d-flex flex-column" style="min-height:100%">
          <div class="flex-fill card card-custom">
            <div class="card-body pt-2 px-5 pb-0">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-26'].description">
                  <span class="font-weight-bolder">{{ mainData['pc-component-26'].name }}</span>
                  <i class="ri-information-line text-muted font-weight-bold pl-5"></i>
                </div>
                <div class="flex-fill d-flex justify-content-end">
                  <a @click="openModalDetail('pc-component-32')" class="d-flex align-items-center pointer text-dark text-hover-primary font-size-sm font-weight-bolder">
                    <span class="pr-2">Detail</span>
                    <i class="ri-arrow-right-line text-dark font-size-sm font-weight-bold"></i>
                  </a>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <table class="font-size-sm table table-small-padding table-head-custom table-vertical-center table-borderlessX table-hoverX">
                  <thead class="bg-secondary-theme">
                    <tr>
                      <th class="nowrap-table">No</th>
                      <th>Nama Dokumen</th>
                      <th class="nowrap-table">Tanggal Dokumen</th>
                      <th class="nowrap-table">P0</th>
                      <th class="nowrap-table">P1</th>
                      <th class="nowrap-table">P2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(m, i) in mainData['pc-component-26'].data">
                      <tr @click="loadDocDetail(m)" class="pointer" :key="i + '-pc-component-26'">
                        <td class="nowrap-table">{{ i + 1 }}</td>
                        <td>
                          <div class="text-line-1">{{ m.contract_document_name }}</div>
                        </td>
                        <td class="nowrap-table">{{ m.contract_document_date | parse('longDate') }}</td>
                        <td class="nowrap-table">{{ m.contract_p0_date | parse('longDate') }}</td>
                        <td class="nowrap-table">{{ m.contract_p1_date | parse('longDate') }}</td>
                        <td class="nowrap-table">{{ m.contract_p2_date | parse('longDate') }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-body pt-2 px-5 pb-0">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-27'].description">
                  <span class="font-weight-bolder">{{ mainData['pc-component-27'].name }}</span>
                  <i class="ri-information-line text-muted font-weight-bold pl-5"></i>
                </div>
                <div class="flex-fill d-flex justify-content-end">
                  <a @click="openModalDetail('pc-component-33')" class="d-flex align-items-center pointer text-dark text-hover-primary font-size-sm font-weight-bolder">
                    <span class="pr-2">Detail</span>
                    <i class="ri-arrow-right-line text-dark font-size-sm font-weight-bold"></i>
                  </a>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <table class="font-size-sm table table-small-padding table-head-custom table-vertical-center table-borderlessX table-hoverX">
                  <thead class="bg-secondary-theme">
                    <tr>
                      <th class="nowrap-table">No</th>
                      <th>Kategori</th>
                      <th>Permasalahan</th>
                      <th class="nowrap-table">Target Penyelesaian</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(m, i) in mainData['pc-component-27'].data">
                      <tr :key="i + '-pc-component-27'">
                        <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ i + 1 }}</td>
                        <td :class="defineClass('priority', m['priority'])">
                          <div class="text-line-1">{{ m.issue_category ? m.issue_category.toUpperCase() : '' }}</div>
                        </td>
                        <td :class="defineClass('priority', m['priority'])">
                          <div class="text-line-1">{{ m.issue_description }}</div>
                        </td>
                        <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.target_closing_date | parse('longDate') }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-body pt-2 px-5 pb-0">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-28'].description">
                  <span class="font-weight-bolder">{{ mainData['pc-component-28'].name }}</span>
                  <i class="ri-information-line text-muted font-weight-bold pl-5"></i>
                </div>
                <div class="flex-fill d-flex justify-content-end">
                  <a @click="openModalDetail('pc-component-34')" class="d-flex align-items-center pointer text-dark text-hover-primary font-size-sm font-weight-bolder">
                    <span class="pr-2">Detail</span>
                    <i class="ri-arrow-right-line text-dark font-size-sm font-weight-bold"></i>
                  </a>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <table class="font-size-sm table table-small-padding table-head-custom table-vertical-center table-borderlessX table-hoverX">
                  <thead class="bg-secondary-theme">
                    <tr>
                      <th class="nowrap-table">No</th>
                      <th>Risiko</th>
                      <th>Dampak</th>
                      <th class="nowrap-table">Risk Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(m, i) in mainData['pc-component-28'].data">
                      <tr :key="i + '-pc-component-28'">
                        <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ i + 1 }}</td>
                        <td :class="defineClass('status_code', m['status_code'])">
                          <div class="text-line-1">{{ m.risk_description }}</div>
                        </td>
                        <td :class="defineClass('status_code', m['status_code'])">
                          <div class="text-line-1">{{ m.risk_impact }}</div>
                        </td>
                        <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ m.risk_response }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-body pt-2 px-5 pb-0">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-29'].description">
                  <span class="font-weight-bolder">{{ mainData['pc-component-29'].name }}</span>
                  <i class="ri-information-line text-muted font-weight-bold pl-5"></i>
                </div>
                <div class="flex-fill d-flex justify-content-end">
                  <a @click="openModalDetail('pc-component-35')" class="d-flex align-items-center pointer text-dark text-hover-primary font-size-sm font-weight-bolder">
                    <span class="pr-2">Detail</span>
                    <i class="ri-arrow-right-line text-dark font-size-sm font-weight-bold"></i>
                  </a>
                </div>
              </div>
              <div class="table-responsive mb-3">
                <table class="font-size-sm table table-small-padding table-head-custom table-vertical-center table-borderlessX table-hoverX">
                  <thead class="bg-secondary-theme">
                    <tr>
                      <th class="nowrap-table">No</th>
                      <th>Tipe Perubahan</th>
                      <th>Dampak Waktu</th>
                      <th>Dampak Biaya</th>
                      <th>Tindak Lanjut</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(m, i) in mainData['pc-component-29'].data">
                      <tr :key="i + '-pc-component-29'">
                        <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ i + 1 }}</td>
                        <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ m.change_type }}</td>
                        <td :class="defineClass('status_code', m['status_code'])">
                          <div class="text-line-1">{{ m.impact_to_time_desc }}</div>
                        </td>
                        <td :class="defineClass('status_code', m['status_code'])">
                          <div class="text-line-1">{{ m.impact_to_cost_desc }}</div>
                        </td>
                        <td :class="defineClass('status_code', m['status_code'])">
                          <div class="text-line-1">{{ m.action_plan_desc }}</div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="row">
          <div class="col-6">
            <div v-if="Array.isArray(mainData['pc-component-23'].data)" class="card-body py-3 px-4 d-flex align-items-center justify-content-center">
              <div class="text-center font-size-h5 font-weight-bolder">
                Waiting
                <br />
                Sistem Informasi QHSE ADHI
              </div>
            </div>
            <template v-else>
              <div class="d-flex align-items-center my-3 font-size-lg" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + 23].description">
                <span class="d-block font-weight-bold text-value">{{ mainData['pc-component-' + 23].name }}</span>
                <i style="line-height: 1;" class="ri-information-line pl-2"></i>
              </div>
              <!-- ========================= -->
              <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3 bg-white">
                <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-warning">
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-md pb-1 svg-icon-warning">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                          <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                          <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                          <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                        </g>
                      </svg>
                    </span>
                  </span>
                </span>
                <div class="d-flex flex-fill align-items-center justify-content-between">
                  <span class="d-block font-weight-bold flex-fill text-value">NC Quality</span>
                  <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['nc-product'].data.total_report_value || 0 | parse('number') }}</span>
                </div>
              </div>
              <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3 bg-white mt-2">
                <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-success">
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-md pb-1 svg-icon-success">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                          <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                          <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                          <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                        </g>
                      </svg>
                    </span>
                  </span>
                </span>
                <div class="d-flex flex-fill align-items-center justify-content-between">
                  <span class="d-block font-weight-bold flex-fill text-value">NC HSE</span>
                  <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['nc-hse'].data.total_report_value || 0 | parse('number') }}</span>
                </div>
              </div>
              <!-- ========================= -->
              <div class="min-w-150px align-items-center border border-muted rounded px-5 py-3 bg-white mt-2">
                <div class="text-center mt-3">
                  <span class="d-block font-weight-bolder text-primary">Single Number Score</span>
                  <h1 style="font-size: 3rem" class="font-weight-boldest text-primary my-2">{{ mainData['pc-component-23'].data['single-number-v2'].data[4].prosentase || 0 | parse('number2fraction') }}%</h1>
                  <!-- <span class="d-block font-weight-bold font-size-sm">Planned</span> -->
                </div>
                <hr class="mb-X" />
                <!-- <div v-for="(x, i) in 4" :key="i + 'snv2-' + i" class="d-flex flex-fill align-items-center justify-content-between mb-2">
                          <span class="d-block font-weight-bold flex-fill text-value text-uppercase">{{ mainData['pc-component-23'].data['single-number-v2'].data[i].title }}</span>
                          <span class="font-size-lg font-weight-bolder text-primary">{{ mainData['pc-component-23'].data['single-number-v2'].data[i].prosentase_result || 0 | parse('number2fraction') }}%</span>
                        </div> -->
                <template v-for="(x, i) in 4">
                  <div :key="i + 'snv2new-' + i" class="d-flex min-w-150px align-items-center py-2">
                    <span class="symbol symbol-circle symbol-40 mr-3 symbol-light-primary">
                      <span class="symbol-label">
                        <span class="svg-icon svg-icon-md pb-1 svg-icon-primary">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                              <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                              <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                              <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </span>
                    <div class="flex-fill ml-2">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="d-block font-weight-bold flex-fill text-uppercase">{{ mainData['pc-component-23'].data['single-number-v2'].data[i].title }}</span>
                      </div>
                      <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['single-number-v2'].data[i].prosentase_result || 0 | parse('number2fraction') }}%</span>
                    </div>
                  </div>
                </template>
              </div>
              <!-- ========================= -->
              <div class="border border-muted rounded px-5 py-3 bg-white mt-2">
                <div class="d-flex min-w-150px align-items-center">
                  <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-success">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1 svg-icon-success">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="d-flex flex-fill align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Severity Rate</span>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['srfrir'].data['sr_value'] || 0 | parse('number') }}</span>
                  </div>
                </div>
                <div class="d-flex min-w-150px align-items-center my-2">
                  <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-success">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1 svg-icon-success">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="d-flex flex-fill align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Frequency Rate</span>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['srfrir'].data['fr_value'] || 0 | parse('number') }}</span>
                  </div>
                </div>
                <div class="d-flex min-w-150px align-items-center">
                  <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-success">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1 svg-icon-success">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="d-flex flex-fill align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Incident Rate</span>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['srfrir'].data['ir_value'] || 0 | parse('number') }}</span>
                  </div>
                </div>
              </div>
              <div class="border border-muted rounded px-5 py-3 bg-white mt-2">
                <div class="d-flex min-w-150px align-items-center">
                  <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-success">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1 svg-icon-success">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="d-flex flex-fill align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Fatality Accident</span>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['k3l-statistic'].data['fatality_accident_value'] || 0 | parse('number') }}</span>
                  </div>
                </div>
                <div class="d-flex min-w-150px align-items-center my-2">
                  <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-success">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1 svg-icon-success">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="d-flex flex-fill align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Incident</span>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['k3l-statistic'].data['incident_value'] || 0 | parse('number') }}</span>
                  </div>
                </div>
                <div class="d-flex min-w-150px align-items-center">
                  <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-success">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1 svg-icon-success">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="d-flex flex-fill align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Nearmiss</span>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['k3l-statistic'].data['nearmiss_value'] || 0 | parse('number') }}</span>
                  </div>
                </div>
              </div>
              <!-- ========================= -->
              <!-- <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3 bg-white mt-2">
                        <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-info">
                          <span class="symbol-label">
                            <span class="svg-icon svg-icon-md pb-1 svg-icon-info">
                              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <rect x="0" y="0" width="24" height="24" />
                                  <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                                  <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                                  <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                                  <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                                </g>
                              </svg>
                            </span>
                          </span>
                        </span>
                        <div class="d-flex flex-fill align-items-center justify-content-between">
                          <span class="d-block font-weight-bold flex-fill text-value">Average Manpower</span>
                          <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['manpower'].data.rerata_manpower || 0 | parse('number') }}</span>
                        </div>
                      </div>
                      <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3 bg-white mt-2">
                        <span class="symbol symbol-circle symbol-25 mr-3 symbol-light-warning">
                          <span class="symbol-label">
                            <span class="svg-icon svg-icon-md pb-1 svg-icon-warning">
                              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <rect x="0" y="0" width="24" height="24" />
                                  <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                                  <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                                  <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                                  <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                                </g>
                              </svg>
                            </span>
                          </span>
                        </span>
                        <div class="d-flex flex-fill align-items-center justify-content-between">
                          <span class="d-block font-weight-bold flex-fill text-value">Total Working Hours</span>
                          <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['manpower'].data.total_jam_kerja || 0 | parse('number') }}</span>
                        </div>
                      </div> -->
              <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3 bg-white mt-2">
                <span class="symbol symbol-circle symbol-40 mr-3 symbol-light-info">
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-md pb-1 svg-icon-info">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                          <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                          <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                          <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                        </g>
                      </svg>
                    </span>
                  </span>
                </span>
                <div class="flex-fill ml-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Average Manpower</span>
                  </div>
                  <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['manpower'].data.rerata_manpower || 0 | parse('number') }}</span>
                </div>
              </div>
              <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3 bg-white mt-2">
                <span class="symbol symbol-circle symbol-40 mr-3 symbol-light-warning">
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-md pb-1 svg-icon-warning">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="0" y="0" width="24" height="24" />
                          <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                          <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                          <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                          <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                        </g>
                      </svg>
                    </span>
                  </span>
                </span>
                <div class="flex-fill ml-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="d-block font-weight-bold flex-fill text-value">Total Working Hours</span>
                  </div>
                  <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-23'].data['manpower'].data.total_jam_kerja || 0 | parse('number') }}</span>
                </div>
              </div>
            </template>
          </div>
          <div class="col-6 pl-0">
            <div class="d-flex align-items-center my-3 font-size-lg">
              <span class="d-block font-weight-bold flex-fill text-value">Earned Value Management</span>
              <!-- <i style="line-height: 1;" class="ri-information-line pl-2"></i> -->
            </div>
            <!-- ========================= -->
            <template>
              <!-- ========================= -->
              <div class="d-flex">
                <div v-for="(x, i) in [13, 12]" :key="i + '--d'" class="flex-fill mb-2">
                  <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'wg-alert' : 'bg-white'" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + x].description">
                    <span class="symbol symbol-circle symbol-40 mr-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'symbol-danger' : 'symbol-light-primary'">
                      <span class="symbol-label">
                        <span class="svg-icon svg-icon-md pb-1" :class="mainData['pc-component-' + x].flag === 'danger' ? 'svg-icon-light' : 'svg-icon-primary'">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                              <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                              <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                              <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </span>
                    <div class="flex-fill ml-2">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
                        <i style="line-height: 1;" class="ri-information-line pl-2" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-mute'"></i>
                      </div>
                      <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-' + x].data || '-' | parse('number2fraction') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ========================= -->
              <div v-for="(x, i) in [14, 17, 18, 19, 15, 16]" :key="i + '--c'" class=" mb-2">
                <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'wg-alert' : 'bg-white'" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + x].description">
                  <span class="symbol symbol-circle symbol-40 mr-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'symbol-danger' : 'symbol-light-primary'">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1" :class="mainData['pc-component-' + x].flag === 'danger' ? 'svg-icon-dark' : 'svg-icon-primary'">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="flex-fill ml-2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
                      <i style="line-height: 1;" class="ri-information-line pl-2" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-mute'"></i>
                    </div>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-' + x].data || '-' | parse('number') }}</span>
                  </div>
                </div>
              </div>
              <!-- =========================  :class="i % 2 ? 'pl-1' : 'pr-1'" -->
              <div class="d-flex flex-column">
                <div v-for="(x, i) in [9, 10]" :key="i + '--d'" class="flex-fill mb-2">
                  <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'wg-alert' : 'bg-white'" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + x].description">
                    <span class="symbol symbol-circle symbol-40 mr-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'symbol-danger' : 'symbol-light-primary'">
                      <span class="symbol-label">
                        <span class="svg-icon svg-icon-md pb-1" :class="mainData['pc-component-' + x].flag === 'danger' ? 'svg-icon-light' : 'svg-icon-primary'">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                              <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                              <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                              <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </span>
                    <div class="flex-fill ml-2">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
                        <i style="line-height: 1;" class="ri-information-line pl-2" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-mute'"></i>
                      </div>
                      <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-' + x].data || '-' | parse('number') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- =========================  :class="i % 2 ? 'pl-1' : 'pr-1'" -->
              <div class="d-flex flex-column">
                <div v-for="(x, i) in [31, 8]" :key="i + '--e'" class="flex-fill mb-2">
                  <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'wg-alert' : 'bg-white'" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + x].description">
                    <span class="symbol symbol-circle symbol-40 mr-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'symbol-danger' : 'symbol-light-primary'">
                      <span class="symbol-label">
                        <span class="svg-icon svg-icon-md pb-1" :class="mainData['pc-component-' + x].flag === 'danger' ? 'svg-icon-light' : 'svg-icon-primary'">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24" />
                              <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                              <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                              <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                              <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </span>
                    <div class="flex-fill ml-2">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
                        <i style="line-height: 1;" class="ri-information-line pl-2" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-mute'"></i>
                      </div>
                      <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-' + x].data || '-' | parse('number') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ========================= -->
              <div v-for="(x, i) in [11]" :key="i + '--f'" class="">
                <div class="d-flex min-w-150px align-items-center border border-muted rounded px-5 py-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'wg-alert' : 'bg-white'" v-b-tooltip.hover placement="topleft" :title="mainData['pc-component-' + x].description">
                  <span class="symbol symbol-circle symbol-40 mr-3" :class="mainData['pc-component-' + x].flag === 'danger' ? 'symbol-danger' : 'symbol-light-primary'">
                    <span class="symbol-label">
                      <span class="svg-icon svg-icon-md pb-1" :class="mainData['pc-component-' + x].flag === 'danger' ? 'svg-icon-dark' : 'svg-icon-primary'">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5" />
                            <rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5" />
                            <rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5" />
                            <rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5" />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  <div class="flex-fill ml-2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="d-block font-weight-bold flex-fill text-value">{{ mainData['pc-component-' + x].name }}</span>
                      <i style="line-height: 1;" class="ri-information-line pl-2" :class="mainData['pc-component-' + x].flag === 'danger' ? 'text-white' : 'text-mute'"></i>
                    </div>
                    <span class="font-size-lg font-weight-bolder text-value">{{ mainData['pc-component-' + x].data || '-' | parse('number') }}</span>
                  </div>
                </div>
              </div>
              <!-- ========================= -->
            </template>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-detail-text" hide-title hide-header hide-footer centered size="xxl">
      <template v-if="mainData && activeDetail">
        <!-- ============================ -->
        <div v-if="activeDetail === 'pc-component-32'" class="" style="page-break-before: always;">
          <div class="d-flex align-items-center justify-content-between mb-3 font-size-lg">
            <span class="font-size-lg font-weight-bolder flex-fill">Contract Logs</span>
          </div>
          <div class="table-responsive">
            <table class="font-size-sm table table-small-padding table-head-custom table-borderlessX table-hoverX">
              <thead class="bg-secondary-theme">
                <tr>
                  <th class="nowrap-table">No</th>
                  <th>Nama Dokumen</th>
                  <th>Nomor Dokumen</th>
                  <th>Nilai Kontrak</th>
                  <th>Nilai Kontrak (inc PPN)</th>
                  <th class="nowrap-table">Tanggal Dokumen</th>
                  <th class="nowrap-table">P0</th>
                  <th class="nowrap-table">P1</th>
                  <th class="nowrap-table">P2</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(m, i) in mainData['pc-component-32'].data">
                  <tr @click="loadDocDetail(m)" class="pointer" :key="i + '-pc-component-32-l'">
                    <td class="nowrap-table">{{ i + 1 }}</td>
                    <td>{{ m.contract_document_name }}</td>
                    <td>{{ m.contract_document_number }}</td>
                    <td>{{ m.contract_inc_ppn_value | parse('money') }}</td>
                    <td>{{ m.value | parse('money') }}</td>
                    <td class="nowrap-table">{{ m.contract_document_date | parse('longDate') }}</td>
                    <td class="nowrap-table">{{ m.contract_p0_date | parse('longDate') }}</td>
                    <td class="nowrap-table">{{ m.contract_p1_date | parse('longDate') }}</td>
                    <td class="nowrap-table">{{ m.contract_p2_date | parse('longDate') }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <!-- ============================ -->
        <div v-else-if="activeDetail === 'pc-component-33'" class="" style="page-break-before: always;">
          <div class="d-flex align-items-center justify-content-between mb-3 font-size-lg">
            <span class="font-size-lg font-weight-bolder flex-fill">Issue Logs</span>
          </div>
          <div class="table-responsive">
            <table class="font-size-sm table table-small-padding table-head-custom table-borderlessX table-hoverX">
              <thead class="bg-secondary-theme">
                <tr>
                  <th class="nowrap-table">No</th>
                  <th>Kategori</th>
                  <th>Permasalahan</th>
                  <th>Akar Permasalahan</th>
                  <th>Tindak Lanjut</th>
                  <th class="nowrap-table">Tanggal Kejadian</th>
                  <th class="nowrap-table">Target Penyelesaian</th>
                  <th class="nowrap-table">Pelapor</th>
                  <th class="nowrap-table">PIC</th>
                  <th class="nowrap-table">Prioritas</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(m, i) in mainData['pc-component-33'].data">
                  <tr :key="i + '-pc-component-33-l'">
                    <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ i + 1 }}</td>
                    <td :class="defineClass('priority', m['priority'])">{{ m.issue_category ? m.issue_category.toUpperCase() : '' }}</td>
                    <td :class="defineClass('priority', m['priority'])">{{ m.issue_description }}</td>
                    <td :class="defineClass('priority', m['priority'])">{{ m.root_cause_description }}</td>
                    <td :class="defineClass('priority', m['priority'])">{{ m.action_plan_description }}</td>
                    <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.issue_date | parse('longDate') }}</td>
                    <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.target_closing_date | parse('longDate') }}</td>
                    <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.issue_reporter }}</td>
                    <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.pic }}</td>
                    <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.priority ? m.priority.toUpperCase() : '' }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <!-- ============================ -->
        <div v-else-if="activeDetail === 'pc-component-34'" class="" style="page-break-before: always;">
          <div class="d-flex align-items-center justify-content-between mb-3 font-size-lg">
            <span class="font-size-lg font-weight-bolder flex-fill">Critical Risk</span>
          </div>
          <div class="table-responsive">
            <table class="font-size-sm table table-small-padding table-head-custom table-borderlessX table-hoverX">
              <thead class="bg-secondary-theme">
                <tr>
                  <th class="nowrap-table">No</th>
                  <th>Sasaran KPI</th>
                  <th>Proses Bisnis</th>
                  <th>Risiko</th>
                  <th>Penyebab</th>
                  <th>Faktor</th>
                  <th>Dampak</th>
                  <th class="nowrap-table">Risk Response</th>
                  <th class="nowrap-table">Risk Owner</th>
                  <th class="nowrap-table">Risk Treatment</th>
                  <th class="nowrap-table">Risk Officer / PIC</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(m, i) in mainData['pc-component-34'].data">
                  <tr :key="i + '-pc-component-34-l'">
                    <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ i + 1 }}</td>
                    <td :class="defineClass('status_code', m['status_code'])">{{ m.kpi_target }}</td>
                    <td :class="defineClass('status_code', m['status_code'])">{{ m.bussiness_process }}</td>
                    <td :class="defineClass('status_code', m['status_code'])">{{ m.risk_description }}</td>
                    <td :class="defineClass('status_code', m['status_code'])">{{ m.cause_description }}</td>
                    <td :class="defineClass('status_code', m['status_code'])">{{ m.risk_factor }}</td>
                    <td :class="defineClass('status_code', m['status_code'])">{{ m.risk_impact }}</td>
                    <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ m.risk_response }}</td>
                    <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ m.risk_owner }}</td>
                    <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ m.risk_treatment }}</td>
                    <td :class="defineClass('status_code', m['status_code'])" class="nowrap-table">{{ m.risk_officer }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <!-- ============================ -->
        <div v-else-if="activeDetail === 'pc-component-35'" class="" style="page-break-before: always;">
          <div class="d-flex align-items-center justify-content-between mb-3 font-size-lg">
            <span class="font-size-lg font-weight-bolder flex-fill">Change Logs</span>
          </div>
          <div class="table-responsive">
            <table class="font-size-sm table table-small-padding table-head-custom table-borderlessX table-hoverX">
                <thead class="bg-secondary-theme">
                  <tr>
                    <th class="nowrap-table">No</th>
                    <th>Tipe Perubahan</th>
                    <th>Deskripsi Perubahan</th>
                    <th>Referensi</th>
                    <th>Dampak Waktu</th>
                    <th>Dampak Biaya</th>
                    <th>Tindak Lanjut</th>
                    <th class="nowrap-table">Tanggal Penyelesaian Tindak Lanjut</th>
                    <th class="nowrap-table">PIC</th>
                    <th class="nowrap-table">Status</th>
                    <th class="nowrap-table">Prioritas</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(m, i) in mainData['pc-component-35'].data">
                    <tr :key="i + '-pc-component-35-l'">
                      <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ i + 1 }}</td>
                      <td :class="defineClass('priority', m['priority'])">{{ m.change_type }}</td>
                      <td :class="defineClass('priority', m['priority'])">{{ m.change_description }}</td>
                      <td :class="defineClass('priority', m['priority'])">{{ m.instruc_change_reference }}</td>
                      <td :class="defineClass('priority', m['priority'])">{{ m.impact_to_time_desc }}</td>
                      <td :class="defineClass('priority', m['priority'])">{{ m.impact_to_cost_desc }}</td>
                      <td :class="defineClass('priority', m['priority'])">{{ m.action_plan_desc }}</td>
                      <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.action_plan_closing_date | parse('longDate') }}</td>
                      <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.pic }}</td>
                      <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.status_code ? m.status_code.toUpperCase() : '' }}</td>
                      <td :class="defineClass('priority', m['priority'])" class="nowrap-table">{{ m.priority ? m.priority.toUpperCase() : '' }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal id="modal-project_contract_log_documents" hide-title hide-header hide-footer centered :size="project_contract_log_documents && project_contract_log_documents.total ? 'xxl' : 'md'">
      <template v-if="project_contract_log_documents && project_contract_log_documents.total">
        <div class="row">
          <div class="col-4">
            <div class="mr-5">
              <div v-for="(x, i) in project_contract_log_documents.data" @click="previewDoc = x" :key="i + '-project_contract_log_documents'" class="d-flex align-items-start mb-3 pointer">
                <div class="symbol symbol-50 symbol-light mr-2">
                  <span class="symbol-label">
                    <img v-if="x.file_name" :src="'static/img/file/' + x.file_name.ext + '.svg'" class="h-75 align-self-center" alt="" />
                    <img v-else :src="'static/img/file/pdf.svg'" class="h-75 align-self-end" alt="" />
                  </span>
                </div>
                <div>
                  <a :class="previewDoc && previewDoc.file_title === x.file_title ? 'text-primary' : 'text-dark'" class="text-line-2 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{ x.file_title }}</a>
                  <a class="text-muted font-weight-bold text-line-1">
                    {{ x.description }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-8">
            <template v-if="previewDoc">
              <div class="d-flex justify-content-between">
                <span class="d-block mr-5 font-size-h4 font-weight-bolder">{{ previewDoc.file_title }}</span>
                <a target="_blank" v-if="previewDoc.file_name" :href="previewDoc.file_name.url" class="text-hover-primary text-primary mb-1 font-size-lg font-weight-bold pointer">Download</a>
              </div>
              <p>{{ previewDoc.description }}</p>
              <template v-if="previewDoc.file_name">
                <hr />
                <embed v-if="supportDisplayInt.includes(previewDoc.file_name.ext)" class="animated" :src="previewDoc.file_name.url" style="width:100%;height:80vh;" />
                <iframe v-else-if="supportDisplayExt.includes(previewDoc.file_name.ext)" class="animated" style="width:100%;height:80vh;" :src="iframeLink(previewDoc.file_name.url, false)" frameborder="0"></iframe>
                <img v-else v-img-fb="previewDoc.file_name.url" class="rounded" style="width:100%;height:80vh;" />
              </template>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class=" text-center mx-auto">
          <img src="static/img/default/no_data_3.svg" class="img-fluid rounded p-5" />
          <span class="d-block mt-5 font-size-lg font-weight-bold">Belum ada dokumen yang diupload</span>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('id')
export default {
  name: 'single-view-pc',
  components: {
    mainFilter: () => import('./../_shared/main-filter.vue')
  },
  props: {
    filterData: { required: true }
  },
  data () {
    return {
      isLoading: true,
      globalFilter: null,
      cleanFilter: null,
      mainData: null,
      evmChartOption: {
        chart: {
          toolbar: {
            enabled: false,
            show: false
          }
        },
        tooltip: {
          theme: 'light'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 2
        },
        markers: {
          size: 3
        },
        // title: { enabled: false },
        title: {
          text: 'In Millions',
          offsetX: 0,
          offsetY: 10,
          style: {
            color: '#FFF',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            cssClass: 'apexcharts-yaxis-title'
          }
        },
        legend: {
          show: true
        },
        grid: {
          show: true,
          position: 'back',
          strokeDashArray: 0,
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        xaxis: {
          type: 'category',
          position: 'bottom',
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: true,
            borderType: 'solid'
          }
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return value ? value.toLocaleString('id-ID') : 0
            }
          },
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: true,
            borderType: 'solid'
          }
        },
        noData: {
          text: 'Loading Chart',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
          }
        }
      },
      performanceChartOption: {
        chart: {
          toolbar: {
            enabled: false,
            show: false
          }
        },
        tooltip: {
          theme: 'light'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 2
        },
        markers: {
          size: 3
        },
        title: { enabled: false },
        legend: {
          show: true
        },
        grid: {
          show: true,
          position: 'back',
          strokeDashArray: 0,
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        xaxis: {
          type: 'category',
          position: 'bottom',
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: true,
            borderType: 'solid'
          }
        },
        yaxis: {
          min: 0,
          max: 2,
          tickAmount: 4,
          // logarithmic: true,
          labels: {
            formatter: (value) => {
              return value ? value.toLocaleString('id-ID') : 0
            }
          },
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: true,
            borderType: 'solid'
          }
        },
        annotations: {
          position: 'front',
          yaxis: [
            {
              y: 1,
              strokeDashArray: 0
            }
          ]
        },
        noData: {
          text: 'Loading Chart',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
          }
        }
      },
      countDown: null,
      intervalRemainingTime: null,
      chartSeries: {
        'pc-component-25': null,
        'pc-component-24': null
      },

      activeDetail: null,
      activeDoc: null,
      project_contract_log_documents: null,
      supportDisplayInt: ['pdf'],
      supportDisplayExt: ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'],
      previewDoc: null
    }
  },
  watch: {
    filterData: {
      deep: true,
      immediate: true,
      handler (e) {
        if (e) this.cleansingFilter(e)
      }
    }
  },
  methods: {
    cleansingFilter (e) {
      const filter = JSON.parse(JSON.stringify(e))
      this.globalFilter = filter
      this.cleanFilter = {
        territory_id: filter.territory_id.code,
        project_id: filter.project_id.code,
        periode_month: filter.periode_month_parsed
      }
      if (filter.project_id.code) {
        this.unselectedProject = false
        this.getAllData(this.cleanFilter)
      } else this.unselectedProject = true
    },
    getAllData (e) {
      this.isLoading = true
      this.$_api
        .get('custom/dashboard/project-control/all-components', e)
        .then((res) => {
          this.mainData = Object.assign({}, res.data)
          this.build24('pc-component-24')
          this.build25('pc-component-25')
          this.$nextTick((x) => {
            this.$_api
              .get('custom/dashboard/project-control/qhse-indicator-components', e)
              .then((res) => {
                this.$set(this.mainData['pc-component-23'], 'data', res.data)
                this.isLoading = false
              })
              .catch((err) => {
                this.$_alert.error(err, 'Error API: \n' + 'QHSE Adhi')
                this.isLoading = false
              })
            clearInterval(this.intervalRemainingTime)
            this.setInterval(res.data)
          })
        })
        .catch((err) => {
          this.isLoading = false
          this.$_alert.error(err, 'Error API: \n' + 'Project Control')
        })
    },
    buildPieOption (e, i = 0) {
      let data = this.mainData[e]
      let color = ['#4498F6', '#24AD75', '#E1A62F']
      let bg = ['#4498F6', '#24AD75', '#E1A62F']
      return {
        chart: {
          type: 'radialBar',
          offsetY: -5
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            fill: color[i],
            hollow: {
              margin: 0,
              size: '65%'
            },
            dataLabels: {
              showOn: 'always',
              name: {
                color: '#FFF',
                show: true,
                fontSize: '12px',
                fontWeight: '700',
                formatter: function (val) {
                  return data.data.cost_value_value
                }
              },
              value: {
                color: bg[i],
                fontSize: '20px',
                fontWeight: '700',
                offsetY: -40,
                show: true,
                formatter: function (val) {
                  return val + '%'
                }
              }
            },
            track: {
              background: '#404059',
              strokeWidth: '100%'
            }
          }
        },
        fill: {
          type: 'solid',
          colors: color[i]
        },
        stroke: {
          lineCap: 'round'
        },
        labels: [data.name]
      }
    },
    build24 (e) {
      if (this.mainData[e]) {
        let data = this.mainData[e].data
        const pv = data.map((z) => {
          return { x: moment(z.periode_month).format('MMM YY'), y: Number(z.pv_value) / 1000000 > 0 ? Number(z.pv_value) / 1000000 : null }
        })
        const ev = data.map((z) => {
          return { x: moment(z.periode_month).format('MMM YY'), y: Number(z.ev_value) / 1000000 > 0 ? Number(z.ev_value) / 1000000 : null }
        })
        const ac = data.map((z) => {
          return { x: moment(z.periode_month).format('MMM YY'), y: Number(z.ac_value) / 1000000 > 0 ? Number(z.ac_value) / 1000000 : null }
        })
        this.chartSeries['pc-component-24'] = [
          { name: 'PV', data: pv },
          { name: 'EV', data: ev },
          { name: 'AC', data: ac }
        ]
      } else this.chartSeries['pc-component-24'] = [{ name: 'waiting', data: [] }]
    },
    build25 (e) {
      if (this.mainData[e]) {
        let data = this.mainData[e].data
        const spi = data.map((z) => {
          return { x: moment(z.periode_month).format('MMM YY'), y: Number(z.spi_value) || null }
        })
        const cpi = data.map((z) => {
          return { x: moment(z.periode_month).format('MMM YY'), y: Number(z.cpi_value) || null }
        })
        this.chartSeries['pc-component-25'] = [
          { name: 'SPI', data: spi },
          { name: 'CPI', data: cpi }
        ]
      } else this.chartSeries['pc-component-25'] = [{ name: 'waiting', data: [] }]
    },
    setInterval (e) {
      let a = JSON.parse(JSON.stringify(e['pc-component-2'].data))
      let b = JSON.parse(JSON.stringify(e['pc-component-1'].data))
      this.intervalRemainingTime = setInterval(() => {
        this.countDown = this.countTime(a, b)
      }, 1000)
    },
    countTime (a, b) {
      const total = moment(new Date()).valueOf() - moment(a, 'YYYY-MM-DD').valueOf()
      const seconds = Math.floor((total / 1000) % 60)
      const minutes = Math.floor((total / 1000 / 60) % 60)
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
      const days = Math.floor(total / (1000 * 60 * 60 * 24))
      const result = {
        days: { name: 'Hari', res: days < 0 ? days * -1 : days },
        hours: { name: 'Jam', res: hours < 0 ? hours * -1 : hours },
        min: { name: 'Menit', res: minutes < 0 ? minutes * -1 : minutes },
        sec: { name: 'Detik', res: seconds < 0 ? seconds * -1 : seconds }
      }
      return [result, !(days < 0)]
    },
    defineClass (type, val) {
      if (!val) return 'xx'
      if (type === 'status_code') {
        if (val.toLowerCase() === 'open') return 'bg-light-danger'
        else if (val.toLowerCase() === 'close') return 'bg-light-success'
        else if (val.toLowerCase() === 'pending') return 'bg-light-warning'
        else return 'xx'
      } else if (type === 'priority') {
        if (val.toLowerCase() === 'high') return 'bg-light-danger'
        else if (val.toLowerCase() === 'low') return 'bg-light-success'
        else if (val.toLowerCase() === 'medium') return 'bg-light-warning'
        else return 'xx'
      } else return 'xx'
    },
    openModalDetail (e) {
      this.activeDetail = e
      this.$bvModal.show('modal-detail-text')
    },
    loadDocDetail (e) {
      this.$_api
        .dataset('project_contract_log_documents', { project_contract_log_id: e.id })
        .then((res) => {
          this.project_contract_log_documents = res
          this.$bvModal.show('modal-project_contract_log_documents')
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    iframeLink (e, intern = true) {
      if (intern) return 'https://docs.google.com/gview?url=' + e + '&embedded=true'
      else return 'https://view.officeapps.live.com/op/embed.aspx?src=' + e
    }
  }
}
</script>

<style>
  @media print {
    @page {
      size: landscape;
    }
    .apexcharts-canvas {
      zoom: 0.7;
    }
    .apexcharts-text,
    .apexcharts-title-text,
    .apexcharts-legend-text {
      fill: #000 !important;
    }
    #print-report {
      zoom: 0.6;
    }
    body,
    .bg-secondary-theme {
      background-color: #fff !important;
      color: #000 !important;
    }
    a:not(.btn) {
      text-decoration: none !important;
    }
    .text-dark {
      color: #000 !important;
    }

    .table,
    .table.table-head-custom thead tr,
    .table.table-head-custom thead th,
    .table.table-head-custom tbody tr,
    .table.table-head-custom tbody td,
    .card,
    .card .card-header,
    .card .card-body {
      background-color: #f9f9f9 !important;
      color: #000 !important;
    }
    .print-only {
      display: block !important;
    }
  }
</style>

<style>
  .print-only {
    display: none;
  }
  #print-report.full-screen {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 999999999999999;
    overflow: hidden;
    background-color: var(--bg-body);
    padding: 0 0.75rem;
  }
  .col-border-radius {
    border: 1.5px solid #58576b;
    border-radius: 8px;
  }
  .nav.nav-tabs.nav-tabs-line .nav-link:hover:not(.disabled),
  .nav.nav-tabs.nav-tabs-line .nav-link.active,
  .nav.nav-tabs.nav-tabs-line .show > .nav-link {
    border-bottom: 2px solid var(--text-theme);
  }
  .wg-warning .text-value {
    color: var(--warning-theme);
  }
  .wg-warning .symbol .symbol-label {
    background-color: var(--warning-light-theme);
  }
  .wg-warning .symbol .symbol-label .svg-icon svg g [fill] {
    fill: var(--warning-theme);
  }

  .wg-success .text-value {
    color: var(--success-theme);
  }
  .wg-success .symbol .symbol-label {
    background-color: var(--success-light-theme);
  }
  .wg-success .symbol .symbol-label .svg-icon svg g [fill] {
    fill: var(--success-theme);
  }

  .wg-info .text-value {
    color: var(--info-theme);
  }
  .wg-info .symbol .symbol-label {
    background-color: var(--info-light-theme);
  }
  .wg-info .symbol .symbol-label .svg-icon svg g [fill] {
    fill: var(--info-theme);
  }

  .wg-danger .text-value {
    color: var(--danger-theme);
  }
  .wg-danger .symbol .symbol-label {
    background-color: var(--danger-light-theme);
  }
  .wg-danger .symbol .symbol-label .svg-icon svg g [fill] {
    fill: var(--danger-theme);
  }

  .wg-primary .text-value {
    color: var(--primary);
  }
  .wg-primary .symbol .symbol-label {
    background-color: var(--primary-light);
  }
  .wg-primary .symbol .symbol-label .svg-icon svg g [fill] {
    fill: var(--primary);
  }

  .wg-alert {
    background: linear-gradient(90deg, var(--danger-theme), var(--danger-light-theme));
    background-color: var(--danger-theme);
    background-size: 200% 200%;
    animation: gradient 2s ease infinite;
    border: 0;
    /* border-color: var(--danger-light-theme); */
  }
  .wg-alert .text-value {
    color: #fff;
  }
  .wg-alert .symbol .symbol-label {
    background-color: var(--danger-theme);
  }
  .wg-alert .symbol .symbol-label .svg-icon svg g [fill] {
    fill: #fff;
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/project-control-single.vue